<template>
  <div class="">
    <Button 
      label="Add"
      class="mb-4"
      size="small"
      icon="pi pi-plus"
      @click="openModal()"
      v-tooltip.left="`Register User`"
    />
    <Dialog v-model:visible="visible" :modal="true" class="p-fluid" header="Register User" :breakpoints="{ '960px': '80vw' }" :style="{ width: '50vw' }" @hide="hideModal()">
      <div class="" style="">
        <div class="flex flex-column gap-2 mt-2">
          <label for="nama">Nama</label>
          <InputText id="nama" v-model="dataForm.nama" aria-describedby="nama-help" :class="{'p-invalid': v$.dataForm.nama.$invalid && afterSubmit}"/>
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="nip">Nip</label>
          <InputText id="nip" v-model="dataForm.nip" aria-describedby="nip-help" :class="{'p-invalid': v$.dataForm.nip.$invalid && afterSubmit}"/>
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="username">Username</label>
          <InputText id="username" v-model="dataForm.username" aria-describedby="username-help" :class="{'p-invalid': v$.dataForm.username.$invalid && afterSubmit}"/>
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="email_user">Email</label>
          <InputText id="email_user" v-model="dataForm.email_user" aria-describedby="email_user-help" :class="{'p-invalid': v$.dataForm.email_user.$invalid && afterSubmit}"/>
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="password">Password</label>
          <Password id="password" :toggleMask="true" :feedback="false" v-model="dataForm.password" aria-describedby="password-help" :class="{'p-invalid': v$.dataForm.password.$invalid && afterSubmit}"/>
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="role">Role</label>
          <Dropdown 
            v-model="dataForm.role" 
            :options="$store.state.data_static.role" 
            optionLabel="text" 
            optionValue="value" 
            placeholder="piilh role" 
            class="w-full" 
            :class="{'p-invalid': v$.dataForm.role.$invalid && afterSubmit}" 
          />
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="foto_user">Foto Profile</label>
          <FileUpload 
            :model="dataForm.file1"
            name="foto_user" 
            ref='file1'
            accept="image/*"
            :previewWidth="100" 
            @select="uploadImage($event)" 
            @remove="uploadImage($event)" 
            :multiple="false" 
            :maxFileSize="1000000"
            :showUploadButton="false"
            :showCancelButton="false"
            chooseLabel="upload Image"
            :disabled="dataForm.file1.length >= 1"
            :pt="{
                root: { style: v$.dataForm.file1.$invalid && afterSubmit ? 'border: 1px solid red; border-radius: 7px;' : '' }
            }"
          >
            <template #empty>
              <p>Drag and drop files to here to upload.</p>
            </template>
          </FileUpload>
        </div>
      </div>
      <template #footer>
        <div class="flex justify-content-end">
          <Button 
            label="Save"
            class=""
            size="small"
            v-tooltip.left="`save`"
            @click="submit()"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email, numeric } from '@vuelidate/validators'
export default {
  emits: [ 'refresh' ],
  components: {
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      afterSubmit: false,
      showPassword: false,
      visible: false,
      dataForm: {
        username: null,
        password: null,
        role: null,
        nama: null,
        nip: null,
        foto_user: null,
        file1: [],
        email_user: null,
      },
    };
  },
  computed: {
    isValid() {
      return !this.v$.dataForm.$invalid;
    },
    isDirty() {
      return this.v$.dataForm.$anyDirty;
    },
  },
  validations () {
    return {
      dataForm: {
        username: { required },
        password: { required },
        role: { required },
        nama: { required },
        nip: { required, numeric },
        file1: { required },
        email_user: { required, email },
      }
    }
  },
  mounted() {
  },
  methods: {
    openModal(){
      const vm = this
      vm.visible = true
      vm.v$.$reset();
    },
    hideModal(){
      const vm = this
      vm.visible = false
      vm.dataForm = {
        username: null,
        password: null,
        role: null,
        nama: null,
        nip: null,
        file1: [],
        email_user: null,
      }
    },
    uploadImage(e){
      const vm = this
      vm.dataForm.file1 = e.files
    },
    async submit(){
      const vm = this
      vm.afterSubmit = true
      if(vm.isValid){
        const dataForm = new FormData()
        dataForm.append('username', vm.dataForm.username)
        dataForm.append('password', vm.dataForm.password)
        dataForm.append('role', vm.dataForm.role)
        dataForm.append('nama', vm.dataForm.nama)
        dataForm.append('nip', vm.dataForm.nip)
        dataForm.append('file1', vm.dataForm.file1[0])
        dataForm.append('email_user', vm.dataForm.email_user)
        const res = await vm.$axios.post('users/register', dataForm)
        if(res.data.status == 200){
          vm.afterSubmit = false
          vm.$emit('refresh')
          vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Register User', life: 3000 });
          vm.visible = false
        }else{
          vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Register User', life: 3000 });
        }
      }else{
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Data Tidak Valid', life: 3000 });
      }
    },
  },
};
</script>